<div class="tooltip-text" *ngIf="value">
    <div [innerHTML]="value"></div>
</div>
